import axiosInstance from "../utils/axios";

export const resetEmail = async (email) => {
  const res = await axiosInstance.post(
    `/account/forgot/send/${email.userEmail}`,
    {}
  );
  return res.data;
};
